import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { E3DLogoutModalContainer } from '../e3d-logout-modal'
import style from './e3dLogoutButton.css'
import { isGrpLoggedInSelector } from '../../../redux/selectors/e3DGrpAuthSelectors'
import { useTranslation } from 'react-i18next'
import LogoutIcon from '../../../assets/media/icons/logout.svg'

type Props = {
    onLogout?: () => void
}

const E3DLogoutButton: React.FC<Props> = ({ onLogout }) => {
    const isLoggedIn = useSelector(isGrpLoggedInSelector)
    const [isModalOpen, setIsModalOpen] = useState(false)
    const { t } = useTranslation()

    const handleLogoutClick = () => {
        setIsModalOpen(true)
    }

    const handleModalClose = () => {
        setIsModalOpen(false)
        if (onLogout) {
            onLogout()
        }
    }

    if (!isLoggedIn) {
        return null
    }

    return (
        <>
            <button className={style.button} onClick={handleLogoutClick} title={t('e3d.logoutTitle')} data-testid="e3d-logout-button">
                <span className={style.icon}>
                    <LogoutIcon />
                </span>
                <span className={style.text}>{t('e3d.logout')}</span>
            </button>
            <E3DLogoutModalContainer isOpen={isModalOpen} onClose={handleModalClose} />
        </>
    )
}

export default E3DLogoutButton
